import { render, staticRenderFns } from "./ScanLayout.vue?vue&type=template&id=1089a9ca&scoped=true&lang=pug&"
import script from "./ScanLayout.vue?vue&type=script&lang=js&"
export * from "./ScanLayout.vue?vue&type=script&lang=js&"
import style0 from "./ScanLayout.vue?vue&type=style&index=0&id=1089a9ca&prod&lang=sass&"
import style1 from "./ScanLayout.vue?vue&type=style&index=1&id=1089a9ca&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1089a9ca",
  null
  
)

/* custom blocks */
import block0 from "./ScanLayout.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports